import type {
  CourseVideoRequest,
  CourseVideoResponse,
  CourseVideoUrlResponse,
  GetCourseVideoListRequest,
  GetCourseVideoListRequestV2,
  GetListResponseOfCourseVideoResponse,
  GetListResponseOfSelectOption,
} from 'src/api/ProactApiClient';
import {courseVideoApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const courseVideoApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getCourseVideoListV2: builder.query<
      GetListResponseOfCourseVideoResponse,
      GetCourseVideoListRequestV2
    >({
      queryFn: clientQuery(request => courseVideoApiClient.listV2(request)),
      providesTags: ['CourseVideos'],
    }),
    getCourseVideoSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetCourseVideoListRequest
    >({
      queryFn: clientQuery(request =>
        courseVideoApiClient.listSelectOptions(request)
      ),
      providesTags: ['CourseVideos'],
    }),
    getCourseVideo: builder.query<CourseVideoResponse, number>({
      queryFn: clientQuery(id => courseVideoApiClient.get(id)),
      providesTags: ['CourseVideos'],
    }),
    getCourseVideoUrl: builder.query<CourseVideoUrlResponse, number>({
      queryFn: clientQuery(id => courseVideoApiClient.getVideoUrl(id)),
      providesTags: ['CourseVideos'],
    }),
    createCourseVideo: builder.mutation<
      CourseVideoResponse,
      CourseVideoRequest
    >({
      queryFn: clientQuery(request => courseVideoApiClient.create(request)),
      invalidatesTags: ['CourseVideos'],
    }),
    updateCourseVideo: builder.mutation<
      CourseVideoResponse,
      CourseVideoRequest
    >({
      queryFn: clientQuery(request => courseVideoApiClient.update(request)),
      invalidatesTags: ['CourseVideos'],
    }),
  }),
});

export const {
  useGetCourseVideoQuery,
  useGetCourseVideoListV2Query,
  useGetCourseVideoSelectOptionsQuery,
  useGetCourseVideoUrlQuery,
  useCreateCourseVideoMutation,
  useUpdateCourseVideoMutation,
} = courseVideoApi;
